// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3y46u","topBottomGutter":"Layout_topBottomGutter__8tDxF"};